import { render, staticRenderFns } from "./AdministrationSanitizationPg.vue?vue&type=template&id=482f3d8c&scoped=true&"
import script from "./AdministrationSanitizationPg.vue?vue&type=script&lang=js&"
export * from "./AdministrationSanitizationPg.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationSanitizationPg.vue?vue&type=style&index=0&id=482f3d8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f3d8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
